/* eslint-disable max-len */
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import EaSuperFeature from '@propertypal/shared/src/resources/icons/products/ea-superfeatured-homepage-icon.svg';
import DevSuperFeatureMockup from '@propertypal/shared/src/resources/images/superfeatured-homepage/dev-superfeatured-mockup.png';
import ProductsPageHeader from '@propertypal/web-ui/src/headers/products/ProductsPageHeader';
import FontAwesomeIcon from '@propertypal/web-ui/src/icons/FontAwesomeIcon';
import ProductsContact from '@propertypal/web-ui/src/products/ProductsContact';
import ProductScreenTabs, { ProductScreenTab } from '@propertypal/web-ui/src/products/ProductScreenTabs';
import { TextLink } from '@propertypal/web-ui/src/typography';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const metaData = {
  title: 'Developers Superfeatured Homepage - PropertyPal',
  description: 'Showcase Developments On The Propertypal Homepage And In The New Homes Section.',
  url: `/products/developers/superfeatured-homepage`,
};

const tabs: ProductScreenTab[] = [
  {
    title: 'Additional exposure',
    text: `Maximise the reach of your development and get noticed with our 'Superfeatured' Spot.`,
    maxW: 370,
  },
  {
    title: 'High imapct',
    text: `Largest ad unit on PropertyPal enabling you to create high impact and receive more clicks through to your development`,
    maxW: 330,
  },
  {
    title: 'Get more enquiries',
    text: `Your development promoted to active buyers before they even begin their search.`,
    maxW: 330,
  },
];

const DeveloperSuperfeaturedHomepage = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <ProductsPageHeader
        title="Superfeatured Homepage"
        text="Showcase your development"
        headingProps={{ mb: 10 }}
        subHeadingProps={{ mb: 0 }}
        icon={<EaSuperFeature />}
      />
      <ProductScreenTabs
        tabs={tabs}
        badge={{
          color: 'primary',
          title: 'MAXIMUM EXPOSURE',
          titleFontSize: 22,
          titleLineHeight: '1.1',
          titleFontSizeMob: 16,
          x: 10,
          xLap: 10,
          xMob: 25,
        }}
        aspectRatio="421 / 250"
        mockupWidth={700}
        negMargin={70}
        maxW={1200}
        breakpoint={1200}
        reverse
        smallPrint={
          <>
            The Superfeatured Homepage is only available to Development Microsite customers. You can find out more about
            Development Microsites{' '}
            <TextLink href="/development-microsites" prefetch={false} display="inline-flex">
              <span>here</span>
              <FontAwesomeIcon
                icon={faChevronRight}
                style={{ marginLeft: '5px', fontSize: '10px', alignSelf: 'center' }}
              />
            </TextLink>
          </>
        }
        pb={30}
        button={{
          onClick: () => document.getElementById('contact-us')?.scrollIntoView({ behavior: 'smooth' }),
          text: 'Contact us',
          containerStyle: { maxWidth: '280px' },
        }}
        staticTabs
        mockup={DevSuperFeatureMockup}
        tabsMt={-15}
        buttonXPadding={15}
        buttonMt={0}
      />
      <ProductsContact reason="Developers Superfeatured Homepage" />
    </>
  );
};

export default DeveloperSuperfeaturedHomepage;
